import { Vue } from 'vue-property-decorator';

export enum EventBusTypes {
  TRANSLATION_UPDATE = 'TRANSLATION_UPDATE'
}

export const EventBus = new Vue();
